import { motion } from "framer-motion";
import { fadeUp, staggerContainer, viewportOnce } from "@/animations/motion";
import { Check } from "@/icons";

interface PillListProps {
  items: string[];
  /** Style: check bullets or plain chips. */
  variant?: "check" | "chip";
  columns?: 1 | 2;
}

/** Renders problems / ideal customers / typical users as a tidy list. */
export function PillList({
  items,
  variant = "check",
  columns = 2,
}: PillListProps) {
  if (variant === "chip") {
    return (
      <motion.ul
        variants={staggerContainer(0.05)}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        className="flex flex-wrap gap-2.5"
      >
        {items.map((item) => (
          <motion.li
            key={item}
            variants={fadeUp}
            className="rounded-full border border-border bg-card px-4 py-2 text-sm text-foreground"
          >
            {item}
          </motion.li>
        ))}
      </motion.ul>
    );
  }

  return (
    <motion.ul
      variants={staggerContainer(0.05)}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      className={columns === 2 ? "grid gap-3 sm:grid-cols-2" : "space-y-3"}
    >
      {items.map((item) => (
        <motion.li key={item} variants={fadeUp} className="flex items-start gap-3">
          <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Check className="h-3 w-3" />
          </span>
          <span className="text-[15px] leading-relaxed text-muted-foreground">
            {item}
          </span>
        </motion.li>
      ))}
    </motion.ul>
  );
}
